import axios from "axios";
import NProgress from "nprogress";

const apiBase = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "",
  headers: {
    accept: "application/json"
  }
});
apiBase.interceptors.request.use(config => {
  NProgress.start();
  return config;
});
apiBase.interceptors.response.use(
  response => {
    NProgress.done();
    return response;
  },
  err => {
    if (err.response.status == 401) {
      if (window.location.href.indexOf("manage")) {
        localStorage.removeItem("manage-api_token");
      }
      if (window.location.href.indexOf("cms")) {
        console.log("removeItem");
        localStorage.removeItem("cms-api_token");
      }
      if (window.location.href.indexOf("platform")) {
        localStorage.removeItem("platform-api_token");
      }
      location.reload();
    }
    NProgress.done();
    return Promise.resolve(err.response);
  }
);

export { apiBase };

// 共用 api

// 台灣縣市鄉鎮
export const getZone = () => apiBase.get("/api/zone");

// 汽車品牌
export const getCategory = () => apiBase.get("/api/category");

// 零件品牌
export const getPartBrand = () => apiBase.get("/api/part-brand");
